module.exports = __webpack_public_path__ + "static/img/type1.a931c4c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sportsBetting/type1.webp
// module id = iWHO
// module chunks = 0